import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { formatarPeriodo } from '@/pages/evento/utils';
import { CapaEvento } from '@/components/ui/CapaEvento';
import { STATUS_EVENTO_CONFIG, textoDoContador } from '../utils';
import type { EventoMeu } from '../types';

interface Props {
  evento: EventoMeu;
}

export default function CartaoMeuEvento({ evento }: Props) {
  const config = STATUS_EVENTO_CONFIG[evento.status] ?? STATUS_EVENTO_CONFIG.rascunho;
  const descricao = evento.descricao?.trim();

  const cidade = [evento.cidade, evento.uf].filter(Boolean).join(', ');
  const dataCidade = [formatarPeriodo(evento.inicio_em, evento.fim_em ?? evento.inicio_em), cidade]
    .filter(Boolean)
    .join(' · ');

  const numeros = textoDoContador(evento);

  return (
    <motion.div
      whileTap={{ scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      className="overflow-hidden rounded-2xl border border-secondary-200 bg-white"
    >
      {/* Banner com a arte do evento — CapaEvento, sem fundo branco */}
      <div className="relative w-full">
        <CapaEvento
          mobile={evento.imagem_mobile_url}
          desktop={evento.imagem_desktop_url}
          alt={evento.nome}
          proporcao="4/5"
          proporcaoDesktop="16/9"
          className="!rounded-none"
        />
        <span
          className={`absolute left-4 top-4 inline-flex items-center whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${config.classes}`}
        >
          {config.rotulo}
        </span>
      </div>

      {/* Descrição e dados abaixo do banner */}
      <div className="p-5">
        <h3 className="text-xl font-semibold leading-snug text-foreground-950">
          {evento.nome}
        </h3>

        {descricao ? (
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {descricao}
          </p>
        ) : null}

        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-foreground-600">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-calendar-line" />
            </span>
            {dataCidade}
          </span>
        </div>

        {numeros ? <p className="mt-2 text-sm text-secondary-500">{numeros}</p> : null}

        {evento.premiosSemFoto ? (
          <Link
            to={`/gerenciar/${evento.id}?aba=sorteio`}
            className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-warning-700 transition-colors hover:text-warning-800"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-image-line" />
            </span>
            Ação entre amigos: {evento.premiosSemFoto}{' '}
            {evento.premiosSemFoto === 1 ? 'prêmio sem foto' : 'prêmios sem foto'}
          </Link>
        ) : null}

        <div className="mt-4 flex flex-wrap gap-2">
          <Link
            to={`/gerenciar/${evento.id}`}
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-dashboard-line" />
            </span>
            Painel
          </Link>
          <Link
            to={`/evento/${evento.id}/editar`}
            className="cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            Editar
          </Link>
        </div>
      </div>
    </motion.div>
  );
}